module.exports = __webpack_public_path__ + "img/gold-loyalty-card.70cd6d8.png";